// extracted by mini-css-extract-plugin
export default {"quiltImg":"styles_quiltImg__qK+7r","quiltText":"styles_quiltText__8-Hgg"};